module.exports = __webpack_public_path__ + "static/img/icon-2-select.75814113.svg";